import { useEffect, useMemo, useState } from "react";
import { apiFetch } from "./api";

export default function AcceptInvite({ onSuccess }) {
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [token, setToken] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    setToken(params.get("token") || "");
  }, []);

  const canSubmit = useMemo(() => {
    return Boolean(token) && password.trim().length >= 8;
  }, [token, password]);

  async function submit(e) {
    e.preventDefault();
    setError("");
    if (!canSubmit) return;

    setBusy(true);
    try {
      const payload = await apiFetch("/auth/invite/accept", {
        method: "POST",
        body: JSON.stringify({ token, password }),
        skipAuthRedirect: true,
        maxRetries: 0,
      });
      if (payload?.token) {
        localStorage.setItem("authToken", payload.token);
      }
      onSuccess?.(payload?.user || null);
    } catch (err) {
      setError(err.message || "Failed to accept invite");
    } finally {
      setBusy(false);
    }
  }

  if (!token) {
    return (
      <div className="card stack">
        <h2 className="h2">Invalid invite link</h2>
        <p className="help">This invite link is missing a token.</p>
      </div>
    );
  }

  return (
    <form className="card stack" onSubmit={submit}>
      <h2 className="h2" style={{ margin: 0 }}>
        Finish setting up your account
      </h2>
      <p className="help">Set up a password.</p>


      <input
        className="input"
        type="password"
        placeholder="New password (min 8 chars)"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        autoComplete="new-password"
      />

      {error && (
        <div className="help" style={{ color: "red" }}>
          {error}
        </div>
      )}

      <button className="btn" type="submit" disabled={!canSubmit || busy}>
        {busy ? "Setting up…" : "Create password & continue"}
      </button>
    </form>
  );
}
